import * as React from 'react';
import styles from './Title.css';

export const Title = ({ Tag, children, ...restProps }) => 
  <Tag className={styles.title} {...restProps}>{children}</Tag>;